import type { SVGProps } from "react";

export const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.0002 5.00977C34.2055 5.00977 32.411 5.69014 31.051 7.05078L8.91619 29.1836C8.49622 29.6036 8.18864 30.1259 8.02557 30.6992L5.05877 41.0879C4.9856 41.345 4.98244 41.6169 5.04962 41.8756C5.11679 42.1343 5.25186 42.3703 5.44085 42.5593C5.62984 42.7483 5.86589 42.8834 6.12459 42.9506C6.38328 43.0177 6.65522 43.0146 6.91229 42.9414L17.3029 39.9746L17.3049 39.9727C17.8744 39.8089 18.3954 39.5052 18.8166 39.084L40.9494 16.9492C43.6705 14.2281 43.6705 9.77191 40.9494 7.05078C39.5894 5.69014 37.7949 5.00977 36.0002 5.00977ZM36.0002 7.99219C37.021 7.99219 38.0404 8.38552 38.8263 9.17188H38.8283C40.4032 10.7467 40.4032 13.2533 38.8283 14.8281L36.8888 16.7676L31.2326 11.1113L33.1721 9.17188C33.958 8.38552 34.9794 7.99219 36.0002 7.99219ZM29.1115 13.2324L34.7678 18.8887L16.6935 36.9629C16.6349 37.0211 16.5606 37.0657 16.4767 37.0898L8.68377 39.3164L10.9103 31.5215V31.5195C10.9333 31.4389 10.9753 31.3667 11.0373 31.3047L29.1115 13.2324Z"
      fill="currentColor"
    />
  </svg>
);
